export const ADDRESS_BOOK_CONSTANTS = {
  ADDRESS_BOOK_RESULTS: $localize`ADDRESS BOOK RESULTS`,
  NAME: $localize`Name`,
  CITY: $localize`City`,
  STATE: $localize`State`,
  POSTAL: $localize`Postal`,
  COUNTRY: $localize`Country`,
  NO_ADDRESS_FOUND: $localize`No address book entries found.`,
};
